module.exports = __webpack_public_path__ + "static/img/image_1.6cebf9d8.png";